import FormFieldCheckBox from '@acorn-portal/shared/src/components/inputs/FormFieldCheckbox';
import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';

import { FieldSet } from '@acorn-portal/shared/src/components/fieldSet';
import { isYoungDriver } from '@acorn-portal/shared/src/utils/is-young-driver';
import { ChangePaymentDate } from '../types';
import { SchemeType } from '@acorn-portal/shared/src/services/interface/Shared';

interface IDayChange {
	title?: string;
	isNonFinancePolicy?: boolean;
	scheme?: SchemeType;
}

const BankDetailsForm: FC<IDayChange> = ({ title, isNonFinancePolicy, scheme }) => {
	const formik = useFormikContext<ChangePaymentDate>();
	const isYDDriver = isYoungDriver(scheme);
	const nonFinancePolicyInstructionText =
		'If your direct debit falls on a weekend or bank holiday, we will collect payment on the next available working day.';
	const financePolicyInstructionText =
		'If your direct debit falls on a weekend or bank holiday Granite Finance will collect payment on the next available working day.';

	return (
		<FieldSet title={title ?? ''}>
			<Typography sx={{ py: '20px' }}>
				{isNonFinancePolicy || isYDDriver ? nonFinancePolicyInstructionText : financePolicyInstructionText}
			</Typography>

			<Typography>
				Please note that once the change to your payment date has been completed you cannot change the payment date
				again for the remainder of your policy term.
			</Typography>

			<Box sx={{ mt: 2 }}>
				<FormFieldCheckBox
					fillWidth
					label=''
					onChange={() => {
						formik.setFieldValue('confirmAffordability', !formik.values.confirmAffordability);
					}}
					onBlur={() => formik.setFieldTouched('confirmAffordability')}
					options={[
						{
							label: (
								<Typography
									color={
										formik.touched.confirmAffordability && Boolean(formik.errors.confirmAffordability)
											? 'error'
											: undefined
									}
								>
									I confirm that the remainder of my monthly instalments will be affordable now and for the duration of
									the agreement on the new payment dates selected.
								</Typography>
							),
							value: formik.values.confirmAffordability,
						},
					]}
					error={formik.touched.confirmAffordability && Boolean(formik.errors.confirmAffordability)}
					helperText={formik.touched.confirmAffordability && formik.errors.confirmAffordability}
				/>
			</Box>
		</FieldSet>
	);
};

export default BankDetailsForm;
